<template>
     <div style="width:350px;margin-left:auto;margin-right:auto">
        <div style="width:100%;text-align:center;margin-top:15px;height:50px" class="headline">Request Payment</div>
         <v-autocomplete
                style="margin:0 auto;height:60px"
                v-model="puser"
                :items="users"
                label="Request To"
                solo
            />
         <v-autocomplete
                style="margin:0 auto;height:60px"
                v-model="bank"
                :items="banks"
                label="Pay Bank"
                solo
            />
         <v-text-field
                type="text"
                v-model="bankname"
                style="margin:0 auto;height:60px"
                label="Enter Bank Name"
                solo
          ></v-text-field>
         <v-text-field
                type="text"
                v-model="accountnumber"
                style="margin:0 auto;height:60px"
                label="Enter Account Number"
                solo
          ></v-text-field>
         <v-text-field
                type="text"
                v-model="utr"
                style="margin:0 auto;height:60px"
                label="Enter UTR REF"
                solo
          ></v-text-field>
         <v-autocomplete
                style="margin:0 auto;height:60px"
                v-model="type"
                :items="paymenttype"
                label="Payment Type"
                solo
            />
         <v-text-field
                type="number"
                v-model="amount"
                style="margin:0 auto;height:60px"
                label="Enter Amount"
                solo
          />
         <v-text-field
                type="text"
                v-model="remark"
                style="margin:0 auto;height:60px"
                label="Enter Remark"
                solo
          />
        <div style="width:100%;float:left;margin-bottom:10px">
            <v-btn color="primary" style="width:100%;margin:0 auto;" @click="submit">Submit</v-btn>
        </div>
     </div>
</template>

<script>
export default {    
    data(){
        return{
            puser:'',
            users:["ADMIN","PARENT"],
            bank:'',
            banks:[],
            bankname:'',
            accountnumber:'',
            utr:'',
            paymenttype:["cash","DD","cheque","NEFT","RGTS","ATMTransfer","MConnect","IMPS","Moneytransfer"],
            amount:'',
            remark:'',
            type:'',
        }
    },
    computed:{
        user(){
            return this.$store.getters.user;
        },
        clear(){
            return this.$store.getters.clear;
        },

    },
    watch:{
        getprovider(value){
            let vm = this;            
            vm.pushoperator();
        },
        clear(value){                        
                this.cleardata();
        }
    },
    methods:{
        errorimg(e){
            e.target.src = require('../assets/logo_single.png')
        },
        cleardata(){
            let vm = this;
            vm.type="";
            vm.amount="";
            vm.remark="";
            vm.utr="";
            vm.accountnumber=""
            vm.bankname="";
            vm.puser="";
            vm.bank=""
        },
        submit(){
            let vm = this;
            if(vm.user.length==0) return vm.$store.dispatch("notify",{vm:vm,message:"Authentication Required!",type:"warn"})
            if(vm.puser=="")return vm.$store.dispatch("notify",{vm:vm,message:"User Type Required",type:"error"})
            if(vm.bank=="")return vm.$store.dispatch("notify",{vm:vm,message:"Select Bank",type:"error"})
            if(vm.bankname=="")return vm.$store.dispatch("notify",{vm:vm,message:"Bank Name Required",type:"error"})
            if(vm.accountnumber=="")return vm.$store.dispatch("notify",{vm:vm,message:"Account Number Required",type:"error"})
            if(vm.utr=="")return vm.$store.dispatch("notify",{vm:vm,message:"UTR Required",type:"error"})
            if(vm.type=="")return vm.$store.dispatch("notify",{vm:vm,message:"Payment Type Required",type:"error"})
            if(vm.amount=="")return vm.$store.dispatch("notify",{vm:vm,message:"Amount Required",type:"error"})
            let params = "?Mob="+vm.user.phone+"&pin="+vm.user.pin+"&Cmd=PayReqAdmin&Amount="+vm.amount+"&PBank="+vm.bank+"&CBank="+vm.bankname+"&CAC="+vm.accountnumber+"&TID="+vm.utr+"&PType="+vm.type+"&Remark="+vm.remark+"&source=ANDROID"
            let data = {
                "Request To":vm.puser,
                "Pay Bank":vm.bank,
                "Bank Name":vm.bankname,
                "Account Number":vm.accountnumber,
                "UTR REF":vm.utr,
                "Payment Type":vm.type,
                "Amount":vm.amount,
                "Remark":vm.remark
            }
            vm.$parent.data = data;
            vm.$parent.params = params.toString();
            vm.$parent.preview = true;

        },
        fetchbank(){ 
         let vm = this;         
         if(vm.user.length==0)return
         let doc  = "?Mob="+vm.user.phone+"&pin="+vm.user.pin+"&Cmd=BNMADMIN&source=ANDROID"        
            vm.$store.dispatch("saxios",{
                data:doc
            }).then(function (doc) {
                let split = doc.data.split("#");
                for(let i =0;i<split.length;i++){
                    if(split[i]!=""){
                        vm.banks.push(split[i].split(",")[1])
                    }
                }
            }).catch(function (error) {
                console.log(error);
                
            }) 
        },
    },
    mounted(){
        let vm = this;
        vm.fetchbank();
    }
}
</script>

<style>
.leftdiv{
    width: 300px;
    float: left;
    margin-bottom:10px;
}
.rightdiv{
    margin-top:10px;
    float: left;
    height: 100px;
}
</style>
